/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { deleteSession } from '../../../../../../../../app/page/page-storage/sessions/sessions.actions';
import { sessionSelectors } from '../../../../../../../../app/resource/session/session.selectors';
import { DAY_MONTH_FORMAT, convertAndFormatDateToUserTimeZone } from '../../../../../../../../utils/date.utils';
import { useSelect, useSelectWithParams } from '../../../../../../../../utils/selector.utils';
import { IKpiHeaderSessionProps } from './types';
import { authSelectors } from '../../../../../../../../app/auth/auth.selectors';
import { userSelectors } from '../../../../../../../../app/resource/user/user.selectors';
import { closeDialog, openDialog } from '../../../../../../../../app/dialog/dialog.actions';

export const KpiHeaderSession: FunctionComponent<IKpiHeaderSessionProps> = ({ sessionId, active, isScrollTarget }) => {
  const session = useSelectWithParams(sessionSelectors.selectResourceById, sessionId);
  const userId = useSelect(authSelectors.selectLoggedUser) || '';
  const user = useSelectWithParams(userSelectors.selectResourceById, userId);
  const dispatch = useDispatch();

  const onDeleteSession = useCallback(() => {
    if (session) {
      dispatch(deleteSession(session.id));
      dispatch(closeDialog('confirmation'));
    }
  }, [dispatch, session]);

  const openConfirmationModal = useCallback(() => {
    dispatch(
      openDialog('confirmation', {
        title: 'Delete meeting date',
        message:
          'Deleting a meeting date is permanent and there is no way to get it back. Do you want to continue anyway?',
        onConfirm: onDeleteSession,
      }),
    );
  }, [dispatch, onDeleteSession]);

  // prepare the header date to the user Time zone
  let sessionDateUserTZ: string | undefined;
  if (session) {
    sessionDateUserTZ = convertAndFormatDateToUserTimeZone(
      session.sessionDate,
      user && user.timezone,
      DAY_MONTH_FORMAT,
    );
  }

  return (
    session && (
      <>
        <div
          className={`kpi-date ${active ? 'active' : ''} ${isScrollTarget ? 'scroll-target' : ''}`}
          style={{ width: '148px', maxWidth: '148px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
        >
          {sessionDateUserTZ}
          <div>
            <a
              className="btn-badge btn-sm mr-05 flex aic jcc red-bg white"
              style={{ marginLeft: '10px' }}
              onClick={openConfirmationModal}
            >
              <i className="icon icon-close f-0" />
            </a>
          </div>
        </div>
      </>
    )
  );
};
